import { cva } from "class-variance-authority";
export { default as Toggle } from "./Toggle.vue";
export { default as ToggleGroupRoot } from "./ToggleGroupRoot.vue";

export const sizes = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "2xl",
    "notification-settings",
];

export const variants = cva(
    [
        "flex",
        "items-center",
        "justify-center",
        "rounded-full",
        "transition-colors",
        "bg-quaternary",
        "fg-quinary",
        "hover:bg-tertiary",
        "hover:fg-quinary_hover",
        "hover:data-[disabled]:bg-quaternary",
        "hover:data-[disabled]:fg-quinary",
        "data-[state=on]:button-primary-bg",
        "data-[state=on]:button-primary-fg",
        "hover:data-[state=on]:button-primary-fg_hover",
        "hover:data-[state=on]:button-primary-bg_hover",
    ],
    {
        variants: {
            size: {
                xs: ["w-6", "h-6", "p-1.5"],
                sm: ["w-8", "h-8", "p-2"],
                md: ["w-10", "h-10", "p-2.5"],
                lg: ["w-12", "h-12", "p-3"],
                xl: ["w-14", "h-14", "p-3"],
                "2xl": ["w-18", "h-18", "p-4"],
                "notification-settings": [
                    "p-[9px]",
                    "md:p-[7px]",
                    "[&>svg]:w-4",
                    "[&>svg]:h-4",
                    "[&>svg]:shrink-0",
                ],
            },
            intermediate: {
                true: [
                    "!bg-utility-brand-100_alt",
                    "!text-utility-brand-500",
                    "hover:!bg-utility-brand-200_alt",
                    "hover:t!ext-utility-brand-600",
                ],
            },
        },
    }
);

export const groupVariants = cva(
    [
        "flex",
        "items-center",
        "p-2",
        "gap-2",
        "bg-primary",
        "border",
        "border-secondary",
        "rounded-full",
    ],
    {
        variants: {
            size: {
                "notification-settings": ["h-13 md:h-11"],
            },
        },
    }
);
